import { timeline } from 'wix-animations'
let stickerTimeline

$w.onReady(function () {

	stickerTimeline = timeline({ repeat: -1 })
	.add($w('#vectorImage2'), { duration: 20000, rotate: 360, easing: 'easeLinear' })
	.play()

});



export function circularbox_mouseIn(event) {
	$w("#circularimage").show()
	// Add your code for this event here: 
}




export function circularbox_mouseOut(event) {
	$w("#circularimage").hide()
		// Add your code for this event here: 
}

export function upcycelbox_mouseIn(event) {
	$w("#upcycleimage").show()
	// Add your code for this event here: 
}

export function upcycelbox_mouseOut(event) {
	$w("#upcycleimage").hide()
	// Add your code for this event here: 
}




export function wovensbox_mouseIn(event) {
	$w("#wovensimage").show()
	// Add your code for this event here: 
}

export function wovensbox_mouseOut(event) {
	$w("#wovensimage").hide()
	// Add your code for this event here: 
}



export function historybox_mouseIn(event) {
	$w("#historyimage").show()
	// Add your code for this event here: 
}

export function historybox_mouseOut(event) {
$w("#historyimage").hide()
	// Add your code for this event here: 
}